module.exports = __webpack_public_path__ + "img/img7.41ff39cd.jpg";